import 'leaflet'
import BasePopup from './BasePopup'
import Vue from 'vue'
import VueMapPopupRelation from '../../../components/map-popup/map-popup-relation.vue'
import VueMapPopupRelationKursk from '../../../components/map-popup/kursk/map-popup-relation.vue'
import {REGION_CODE} from "../../../config/config";

const MapPopupRelation = BasePopup.extend({
  getVueComponent: function () {
    if(REGION_CODE == 46){
      return new Vue(VueMapPopupRelationKursk)
    } else {
      return new Vue(VueMapPopupRelation)
    }

  }
})

export default MapPopupRelation
